export default __webpack_public_path__ + "static/media/buddy10.e940096a.jpg";